import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';

export default {
  date: state => state.date,
  calendar: state => state.calendar,
  calendarByMonth: state => state.calendarByMonth,
  fetchDiaryList: state => {
    let list = cloneDeep(state.calendar);
    let diaryList = [];

    list.forEach(e => {
      e.diary.forEach(d => {
        diaryList.push(d);
      });
    });

    diaryList.sort((a, b) => {
      return dayjs(a.date) - dayjs(b.date);
    });
    return diaryList;
  },
  selectDate: state => {
    let date = state.date;

    return dayjs(date).get('date');
  },
  getDetail: state => state.detail
};
